import React, { Component } from 'react';
import { connect } from 'react-redux';
import { updateButtonText }  from '../../actions/SettingsAction';

import './ButtonPad.css';

class ButtonPad extends Component {
	
	constructor(props){
		super(props);
		
		this.handleKeyPress = this.handleKeyPress.bind(this);
		this.handleClick = this.handleClick.bind(this);

		this.qRef = React.createRef();
		this.wRef = React.createRef();
		this.eRef = React.createRef();
		this.aRef = React.createRef();
		this.sRef = React.createRef();
		this.dRef = React.createRef();
		this.zRef = React.createRef();
		this.xRef = React.createRef();
		this.cRef = React.createRef();
		
		this.bank1 = [
			{
				name: 'Heater-1',
				url: 'https://s3.amazonaws.com/freecodecamp/drums/Heater-1.mp3'
			},
			{
				name: 'Heater-2',
				url: 'https://s3.amazonaws.com/freecodecamp/drums/Heater-2.mp3'
			},
			{
				name: 'Heater-3',
				url: 'https://s3.amazonaws.com/freecodecamp/drums/Heater-3.mp3'
			},
			{
				name: 'Heater-4',
				url: 'https://s3.amazonaws.com/freecodecamp/drums/Heater-4_1.mp3'
			},
			{
				name: 'Clap',
				url: 'https://s3.amazonaws.com/freecodecamp/drums/Heater-6.mp3'
			},
			{
				name: 'Open HH',
				url: 'https://s3.amazonaws.com/freecodecamp/drums/Dsc_Oh.mp3'
			},
			{
				name: 'Kick N\' Hat',
				url: 'https://s3.amazonaws.com/freecodecamp/drums/Kick_n_Hat.mp3'
			},
			{
				name: 'Kick',
				url: 'https://s3.amazonaws.com/freecodecamp/drums/RP4_KICK_1.mp3'
			},
			{
				name: 'Closed HH',
				url: 'https://s3.amazonaws.com/freecodecamp/drums/Cev_H2.mp3'
			}
		];
		
		this.bank2 = [
			{
				name: 'Chord-1',
				url: 'https://s3.amazonaws.com/freecodecamp/drums/Chord_1.mp3'
			},
			{
				name: 'Chord-2',
				url: 'https://s3.amazonaws.com/freecodecamp/drums/Chord_2.mp3'
			},
			{
				name: 'Chord-3',
				url: 'https://s3.amazonaws.com/freecodecamp/drums/Chord_3.mp3'
			},
			{
				name: 'Shaker',
				url: 'https://s3.amazonaws.com/freecodecamp/drums/Give_us_a_light.mp3'
			},
			{
				name: 'Open-HH',
				url: 'https://s3.amazonaws.com/freecodecamp/drums/Dry_Ohh.mp3'
			},
			{
				name: 'Closed-HH',
				url: 'https://s3.amazonaws.com/freecodecamp/drums/Bld_H1.mp3'
			},
			{
				name: 'Punchy-Kick',
				url: 'https://s3.amazonaws.com/freecodecamp/drums/punchy_kick_1.mp3'
			},
			{
				name: 'Side-Stick',
				url: 'https://s3.amazonaws.com/freecodecamp/drums/side_stick_1.mp3'
			},
			{
				name: 'Snare',
				url: 'https://s3.amazonaws.com/freecodecamp/drums/Brk_Snr.mp3'
			}
		
		];

	}

	componentWillMount(){
		document.addEventListener("keydown", this.handleKeyPress.bind(this));
	}

	handleKeyPress(e){

		switch(e.key){
			case 'q':
				this.qRef.current.click();
				break;
			case 'w':
				this.wRef.current.click();
				break;
			case 'e':
				this.eRef.current.click();
				break;
			case 'a':
				this.aRef.current.click();
				break;
			case 's':
				this.sRef.current.click();
				break;
			case 'd':
				this.dRef.current.click();
				break;
			case 'z':
				this.zRef.current.click();
				break;
			case 'x':
				this.xRef.current.click();
				break;
			case 'c':
				this.cRef.current.click();
				break;
			default:	
		}
	}
	
	handleClick(e){

		let audio;
		let bank = this.props.bankOn? this.bank2 : this.bank1;

		if(!this.props.powerOn)
			return;
		
		switch(e.target.name){
			case 'q':
				audio = new Audio(bank[0].url);
				audio.volume = this.props.volume;
				audio.play();
				this.props.updateButtonText(bank[0].name);
				break;
			case 'w':
				audio = new Audio(bank[1].url);
				audio.volume = this.props.volume;
				audio.play();
				this.props.updateButtonText(bank[1].name);
				break;
			case 'e':
				audio = new Audio(bank[2].url);
				audio.volume = this.props.volume;
				audio.play();
				this.props.updateButtonText(bank[2].name);
				break;
			case 'a':
				audio = new Audio(bank[3].url);
				audio.volume = this.props.volume;
				audio.play();
				this.props.updateButtonText(bank[3].name);
				break;
			case 's':
				audio = new Audio(bank[4].url);
				audio.volume = this.props.volume;
				audio.play();
				this.props.updateButtonText(bank[4].name);
				break;
			case 'd':
				audio = new Audio(bank[5].url);
				audio.volume = this.props.volume;
				audio.play();
				this.props.updateButtonText(bank[5].name);
				break;
			case 'z':
				audio = new Audio(bank[6].url);
				audio.volume = this.props.volume;
				audio.play();
				this.props.updateButtonText(bank[6].name);
				break;
			case 'x':
				audio = new Audio(bank[7].url);
				audio.volume = this.props.volume;
				audio.play();
				this.props.updateButtonText(bank[7].name);
				break;
			case 'c':
				audio = new Audio(bank[8].url);
				audio.volume = this.props.volume;
				audio.play();
				this.props.updateButtonText(bank[8].name);
				break;
			default: 
				console.log('Not applicable');
		}
		
	}

	render(){

		return (
			<div className="ButtonPad" >
				<button 
					onClick={this.handleClick}
					className={`btn`}
					name='q'
					ref={this.qRef}>Q</button>
				<button 
					onClick={this.handleClick}
					className={`btn`}
					name='w'
					ref={this.wRef}>W</button>
				<button 
					onClick={this.handleClick}
					className={`btn`}
					name='e'
					ref={this.eRef}>E</button>


				<button 
					onClick={this.handleClick}
					className={`btn`}
					name='a'
					ref={this.aRef}>A</button>
				<button 
					onClick={this.handleClick}
					className={`btn`}
					name='s'
					ref={this.sRef}>S</button>
				<button 
					onClick={this.handleClick}
					className={`btn`}
					name='d'
					ref={this.dRef}>D</button>
				
				<button 
					onClick={this.handleClick}
					className={`btn`}
					name='z'
					ref={this.zRef}>Z</button>
				<button 
					onClick={this.handleClick}
					className={`btn`}
					name='x'
					ref={this.xRef}>X</button>
				<button 
					onClick={this.handleClick}
					className={`btn`}
					name='c'
					ref={this.cRef}>C</button>
			</div>
		);	
	}
}

const mapStateToProps = state => ({
	volume: state.settings.volume,
	bankOn: state.settings.bankOn,
	powerOn: state.settings.powerOn
});

export default connect(mapStateToProps, {updateButtonText})(ButtonPad);


